var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,385.2H45.6c-16.8,0-31.2,14.4-31.2,31.2V546c0,16.8,14.4,31.2,31.2,31.2h18c16.8,0,31.2-14.4,31.2-31.2 V416.4C94.8,399.6,81.6,385.2,64.8,385.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1154.4,405.6h-18c-16.8,0-31.2,14.4-31.2,31.2v129.6c0,16.8,14.4,31.2,31.2,31.2h18 c16.8,0,31.2-14.4,31.2-31.2l0-129.6C1185.6,418.8,1171.2,405.6,1154.4,405.6L1154.4,405.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M985.2,160.8C876,120,600,117.6,600,117.6s-277.2,2.4-386.4,43.2c-109.2,40.8-92.4,120-92.4,120v663.6 c0,51.6,42,92.4,92.4,92.4h10.8v42c0,16.8,14.4,31.2,31.2,31.2h121.2c16.8,0,31.2-14.4,31.2-31.2v-42h384v42 c0,16.8,14.4,31.2,31.2,31.2h121.2c16.8,0,31.2-14.4,31.2-31.2v-42h10.8c51.6,0,92.4-42,92.4-92.4l0-664.8 C1077.6,279.6,1094.4,201.6,985.2,160.8L985.2,160.8z M504,196.8c0-7.2,6-13.2,13.2-13.2h165.6c7.2,0,13.2,6,13.2,13.2v36 c0,7.2-6,13.2-13.2,13.2H517.2c-7.2,0-13.2-6-13.2-13.2L504,196.8z M376.8,848.4c0,15.6-12,27.6-27.6,27.6H242.4 c-15.6,0-27.6-12-27.6-27.6v-57.6c0-8.4,3.6-16.8,10.8-21.6c7.2-4.8,15.6-7.2,24-4.8l106.8,28.8c12,3.6,20.4,14.4,20.4,26.4 L376.8,848.4z M232.8,686.4c-9.6,0-16.8-7.2-16.8-16.8V332.4c0-9.6,7.2-16.8,16.8-16.8h730.8c9.6,0,16.8,7.2,16.8,16.8v337.2 c0,9.6-7.2,16.8-16.8,16.8H232.8z M984,848.4c0,15.6-12,27.6-27.6,27.6H849.6c-15.6,0-27.6-12-27.6-27.6v-28.8 c0-12,8.4-22.8,20.4-26.4l106.8-28.8c8.4-2.4,16.8,0,24,4.8c7.2,4.8,10.8,13.2,10.8,21.6L984,848.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.c53668db1d2df78f880a2d0b942adc5d.svg";
export { ForwardRef as ReactComponent };